<template>
    <div>
        <buscar-movimento-compra
            @pesquisarMovimentoCompra="pesquisarMovimentoCompra($event)"
            @inserir="inserirDespesaCompra($event)"
            :erros="erros"
            :movimento="movimento"
        >
            <template slot="botoes">
                <app-btn-voltar></app-btn-voltar>
            </template>
        </buscar-movimento-compra>
        <router-view></router-view>
    </div>
</template>

<script>
import BuscarMovimentoCompra from '@/app/despesasgerais/componentes/despesas/BuscarMovimentoCompra.vue';
import DespesasServicos from './DespesasServicos';

export default {
    components: {
        BuscarMovimentoCompra
    },

    data() {
        return {
            opcoes: {},
            fornecedor: {},
            movimento: null,
            erros: []
        }
    },

    methods: {
        pesquisarMovimentoCompra(movimentoId) {
            this.$store.dispatch('addRequest')
            DespesasServicos.pesquisarMovimentoCompra(movimentoId).then(response => {
                if (response) {
                    if (response.success) {
                        this.movimento = response.data
                        this.erros = []
                    } else {
                        this.erros = response.errors
                        this.movimento = null
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        inserirDespesaCompra(despesaDto) {
            this.$store.dispatch("addRequest")
            DespesasServicos.inserirDespesaCompra(despesaDto).then(response => {
                if (response) {
                    if (response.success && response.data != null) {
                        this.$toast.success(
                            'Despesa inserida com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.detalharDespesa(response.data)
                    } else {
                        this.erros =  response.errors
                    }
                }
                this.$store.dispatch("removeRequest")
            })
        },

        detalharDespesa(id) {
            this.$router.push({
                name: `DespesasGerais_Requisitantes_Despesas_Detalhar`,
                params: {
                    despesaId: id
                }
            })
        }
    },

    created() {},  

    computed: {}
}

</script>